// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsCustomAttributeUsageResult = anyOf(
  objectOf({
    custom_attribute_count: number,
    custom_attribute_max: number,
  }),
  objectOf({})
);
